import { render, staticRenderFns } from "./qyxx.vue?vue&type=template&id=445195a9&scoped=true"
import script from "./qyxx.vue?vue&type=script&lang=js"
export * from "./qyxx.vue?vue&type=script&lang=js"
import style0 from "./qyxx.vue?vue&type=style&index=0&id=445195a9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445195a9",
  null
  
)

export default component.exports